import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { Bank } from '../model/bank';

@Injectable({
    providedIn: 'root'
  })
  export class BankService{
  
    constructor(private _restClientService : RestClientService) { }

            
    getAllBanks() {
      return this._restClientService.load<Bank[]>('bank/banks');
    }
      
        
    getAllBanksByCity(city:String) {
      return this._restClientService.load<Bank[]>('bank/banks-by-city?city='+city);
    }
    
    
    getBankById(bankId){
      return this._restClientService.load<Bank>('bank/bank-by-id/'+bankId);
    }
    
    
    putBank(bank) {
      return  this._restClientService.put<Bank>(`bank/update-bank`, bank);
    }
    

    postBank(bank) {
      return  this._restClientService.save<Bank>('bank/add-bank', bank);
    }
    

}      

    